import { render } from "./ContactModal.vue?vue&type=template&id=6a40cec5"
import script from "./ContactModal.vue?vue&type=script&lang=js"
export * from "./ContactModal.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/jeronimo/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__